import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import InfoIcon from '@mui/icons-material/Info';
import avtar from "../../assets/images/Profile-Picture.jpg";
import document from "../../assets/images/updated-aadhaar.png";
import PlaceIcon from '@mui/icons-material/Place';
import Zoom from "react-medium-image-zoom";
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 10,
    p: 3,
};
  
function MobileTenantDetails() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [SelectBuilding, setSelectBuilding] = useState('');
    const [selectWing, setSelectWing] = useState('');
    const [selectApartment, setSelectApartment] = useState('');
    const handleChangeBuilding = (event) => {
        setSelectBuilding(event.target.value);
    };
    const handleChangeWing = (event) => {
        setSelectWing(event.target.value);
    };
    const handleChangeApartment = (event) => {
        setSelectApartment(event.target.value);
    };
    
    const initialValues = {
      first_name: "",
      last_name: "",
      age: "",
      phone_no: "",
      email: "",
      total_family_mem: "",
    };
  
    const validationSchema = Yup.object({
      first_name: Yup.string().required("Required"),
      last_name: Yup.string().required("Required"),
      age: Yup.string().required("Required"),
      phone_no: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      total_family_mem: Yup.string().required("Required"),
    });
  
    const onSubmit = (values) => console.log("Form Data", values);
  return (
    <>
      <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          {/* <MobileDrawer /> */}
          <ArrowBackIcon
            className="backArrowMobil"
            onClick={() => navigate("/MobileTenantInfo")}
          />
          <h1>Tenant Details</h1>
        </div>
      </div>
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="famDetailsListMainMob">
            <div className="famDetailsListInrMob">
            <div className="RightIconViewEditDelete">
                <p className="MainDetailsTxt">Tenant</p>
                <div className="EditDeleteIconView">
                <CreateIcon style={{ color: "#21bd21" }} onClick={handleOpen}/>
                <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div>
            </div>
            <div className='dividerCommon' />
              <div className="famDetailsListTo margineTop10">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage"/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <p>28 Years</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="famDetailsListBot">
                <p>
                  <LocalPhoneIcon /> <span>test@gmail.com</span>
                </p>
                <p>
                  <EmailIcon /> <span>test@gmail.com</span>
                </p>
                <p>
                  <PlaceIcon /> <span>Sai Plaza/A/F-101</span>
                </p>
                <p>
                  <PeopleAltIcon /> <span>4 Members</span>
                </p>
              </div>
              <p className="VehicleDocumentMainTxt">Document's</p>
            <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                    <Zoom>
                    <img src={document} />
                    </Zoom>
                </div>
                <h1 className="MobUploadedtx">uploaded file</h1>
            </div>
            </div>
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Edit Tenant Details</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <div className="scrollDivModal">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
          <Form>
          <div className='FormView'>
          <div className="CenterImageView margineTop10">
          <div className="EditProfileImageView">
              <img src={avtar} className="EditProfileImage" />
            <div className="EditIconImageView">
              <CreateIcon sx={{fontSize:20, color:'#0044ff'}}/>
              <input type='file' className='ImageEditBtn'/>
            </div>
          </div>
          </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="First Name"
              placeholder="Enter First Name"
              labelclassName="inputLebal"
              name="first_name"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Last Name"
              placeholder="Enter Last Name"
              labelclassName="inputLebal"
              name="last_name"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Age"
              placeholder="Enter Age"
              labelclassName="inputLebal"
              name="age"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Phone Number"
              placeholder="Enter Phone Number"
              labelclassName="inputLebal"
              name="phone_no"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Email"
              placeholder="Enter Email"
              labelclassName="inputLebal"
              name="email"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Total Family Member"
              placeholder="Enter Total Family Member"
              labelclassName="inputLebal"
              name="total_family_mem"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <p className='inputLebal'>Select Building</p>
            <Select
                value={SelectBuilding}
                onChange={handleChangeBuilding}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'A'}>Building ABC</MenuItem>
                <MenuItem value={'B'}>Building DEF</MenuItem>
                <MenuItem value={'C'}>Building PQR</MenuItem>
                </Select>
            </div>
            <div className='lebalInputView'>
            <p className='inputLebal'>Select Wing</p>
            <Select
                value={selectWing}
                onChange={handleChangeWing}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'A'}>Wing A</MenuItem>
                <MenuItem value={'B'}>Wing B</MenuItem>
                <MenuItem value={'C'}>Wing C</MenuItem>
                </Select>
            </div>
            <div className='lebalInputView'>
            <p className='inputLebal'>Select Apartment</p>
            <Select
                value={selectApartment}
                onChange={handleChangeApartment}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'A'}>Apartment A</MenuItem>
                <MenuItem value={'B'}>Apartment B</MenuItem>
                <MenuItem value={'C'}>Apartment C</MenuItem>
                </Select>
            </div>
            
            <div className='attchmentView'>
              <AttachmentIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Document's</p>
            </div>
            <div className='attchmentView'>
              <p className='fileName'>File name</p>
              <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
            </div>
            <button className='submitButton' type='submit'>Update</button>
          </div>
          </Form>
            )}
          </Formik>
          </div>
        </Box>
        </Modal>
        </div>
      </div>
    </>
  )
}

export default MobileTenantDetails